'use es6';

import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import { setActivePatagoniaPanel, closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import PatagoniaSidebarHeader from 'ContentEditorUI/components/sidebar/PatagoniaSidebarHeader';
import { getCanMABExperiment } from 'page-editor-ui/redux/selectors/mabExperimentSelectors';
import PatagoniaRunATestWrapper from 'page-editor-ui/containers/PatagoniaRunATestWrapper';
import { toggleRunTestModal, setTestType } from 'ContentEditorUI/redux/actions/appActions';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaToolsMenu = () => {
  const dispatch = useDispatch();
  const canMABExperiment = useSelector(getCanMABExperiment);
  const handleOpenTestModal = testType => {
    dispatch(closePatagoniaSidebar());
    dispatch(setTestType(testType));
    dispatch(toggleRunTestModal(true));
    UsageTracker.trackEditorInteraction({
      action: 'Navigation Action',
      event: 'clicked-run-a-test'
    });
  };
  const handleToolSelection = testType => {
    dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.tools));
    handleOpenTestModal(testType);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(PatagoniaSidebarHeader, {
      headerText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "patagonia.sidebar.testHeader"
      })
    }), /*#__PURE__*/_jsx(SideNav, {
      "data-test-id": "tools-menu",
      paddingInlineStart: "400",
      children: canMABExperiment && /*#__PURE__*/_jsx(PatagoniaRunATestWrapper, {
        openRunTestModal: handleToolSelection
      })
    })]
  });
};
export default PatagoniaToolsMenu;